var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "10px",
    viewBox: "0 0 18 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-arrow-right") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Custom-Host-Pop-Up-Copy",
    transform: "translate(-834.000000, -474.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(623.000000, 461.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-30",
    transform: "translate(148.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-arrow-right",
    transform: "translate(63.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,5 C0,4.4477 0.44772,4 1,4 L17,4 C17.5523,4 18,4.4477 18,5 C18,5.5523 17.5523,6 17,6 L1,6 C0.44772,6 0,5.5523 0,5 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2929,0.29289 C12.6834,-0.09763 13.3166,-0.09763 13.7071,0.29289 L17.7071,4.2929 C18.0976,4.6834 18.0976,5.3166 17.7071,5.7071 C17.3166,6.0976 16.6834,6.0976 16.2929,5.7071 L12.2929,1.70711 C11.9024,1.31658 11.9024,0.68342 12.2929,0.29289 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7071,4.2929 C18.0976,4.6834 18.0976,5.3166 17.7071,5.7071 L13.7071,9.7071 C13.3166,10.0976 12.6834,10.0976 12.2929,9.7071 C11.9024,9.3166 11.9024,8.6834 12.2929,8.2929 L16.2929,4.2929 C16.6834,3.9024 17.3166,3.9024 17.7071,4.2929 Z",
    id: "Path"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow_right.e249fdec.svg";
export { ForwardRef as ReactComponent };